export class TipoDeposito {
    //  ? significa opcional
            public codTipoDeposito: number;
             public descripcion: string;
            public codEmpresa: number;
             constructor( ) { }
    }
